import * as routesUtils from '../utils/RoutesUtils'
import { API } from '../core/app.routes'
import httpClient from '../core/httpClient'

const workorderService = () => {
  return {
    getMany: params => {
      const path = routesUtils.getApiPath(API.WORKORDERS, params)
      return httpClient.get(path)
    },
    get: workOrderId => {
      const path = routesUtils.getApiPath(API.WORKORDER_DETAIL, { workOrderId })
      return httpClient.get(path)
    },
  }
}

export default workorderService
